<div class="tag-container" [class.closed]="!isOpen" [class.open]="isOpen">

    <span class="material-icons toggle"
          (click)="toggleOpen($event)">local_offer</span>
    <span class="material-icons toggle button close-button transparent"
          [class.opaque]="isOpen"
          (click)="toggleOpen($event)">close</span>
    @if (userIsAdmin)
    {
        <span class="material-icons toggle button add-button transparent"
              [class.opaque]="isOpen"
              (click)="toggleShowTags($event)">{{showExisting ? "add_box" : "backspace"}}</span>
    }

    @if (!showExisting)
    {
        <div class="tag new">
            <input type="text" maxlength="15" placeholder="new tag"
                   (click)="$event.stopPropagation()"
                   (keyup)="cleanTagName($event.target)"
                   (keyup.enter)="createTag(newtag.value, $event)"
                   #newtag />
            <span class="material-icons"
                  (click)="createTag(newtag.value, $event)">add</span>
        </div>
    }

    @if (!showExisting && userIsAdmin)
    {
        <div>
            @for (tag of galleryTags; track tag; let shortcut = $index)
            {
                <div class="tag gallery"
                     [class.existing]="hasTag(tag)">
                    <span (click)="showTag(tag, $event)">
                        {{tag}}
                        @if (shortcut < maxShortcuts)
                        {
                            <span class="shortcut">{{getShortcutText(shortcut + 1, "a")}}</span>
                        }
                    </span>
                    <span class="material-icons"
                          (click)="toggleTag(tag, $event)">{{hasTag(tag) ? "clear" : "add"}}</span>
                </div>
            }
        </div>
    }

    @for (tag of tags; track tag; let shortcut = $index)
    {
        <div class="tag"
             [class.existing]="hasTag(tag)">
            <span (click)="showTag(tag, $event)">
                {{tag}}
                @if (!showExisting && shortcut < maxShortcuts)
                {
                    <span class="shortcut">{{getShortcutText(shortcut + 1)}}</span>
                }
            </span>
            @if (userIsAdmin)
            {
                <span class="material-icons"
                      (click)="toggleTag(tag, $event)">{{hasTag(tag) ? "clear" : "add"}}</span>
            }
        </div>
    }

</div>
